import * as React from 'react';
import { AppConfig } from '@core/utils/config';
import { useSubscribe } from '../rxjs';

export function useConfig(options: { onChange?: (info: AppConfig.Data) => void } = {}) {
  const currentValue = AppConfig.changed$.value;
  const [config, setConfig] = React.useState<AppConfig.Data>(currentValue);

  const callback = options.onChange;

  const callbackRef = React.useRef(callback);

  callbackRef.current = callback;

  useSubscribe(AppConfig.changed$, conf => {
    setConfig(conf);
    if (callbackRef.current) callbackRef.current(conf);
  });

  return config;
}
